module.exports = __webpack_public_path__ + "static/media/unloaded_pass.919e3f90.svg";